var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEasy360RedAndBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 636.43 235.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_217);}.cls-2{fill:url(#Gradiente_sem_nome_214);}.cls-3{fill:#0296f2;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_217",
    x1: 389.47,
    y1: 235.11,
    x2: 389.47,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f21b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f21b1b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f21b1b",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f21b1b",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f21b1b",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f21b1b",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f21b1b",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f21b1b",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f21b1b",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f21b1b",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_214",
    x1: 244.26,
    y1: 235.11,
    x2: 244.26,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f21b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f21b1b",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f21b1b",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f21b1b",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f21b1b",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f21b1b",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f21b1b",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f21b1b",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f21b1b",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.46 0 145.2 235.11 233.48 235.11 633.73 0 545.46 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 235.11 88.27 235.11 488.52 0 400.25 0 0 235.11"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.03,18.54h-6.61c-5.62,0-10.58,3.64-13.22,8.85l-41.75,82.21h17.84l13.99-27.32h52.87l13.99,27.32h17.84L187.24,27.39c-2.64-5.21-7.6-8.85-13.22-8.85Zm-20.49,45.53l13.88-27.32h6.61l13.88,27.32h-34.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "400.21 109.6 400.21 68.1 447.13 18.54 424 18.54 392.39 51.84 360.89 18.54 337.76 18.54 384.68 68.1 384.68 109.6 400.21 109.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.29,54.97h-61.68c-4.19,0-7.71-4.03-7.71-9.11s3.52-9.11,7.71-9.11h84.68l-17.24-18.21h-67.44c-12.67,0-23.13,12.23-23.13,27.32s10.46,27.32,23.13,27.32h61.68c4.18,0,7.71,4.03,7.71,9.11s-3.53,8.98-7.71,8.98h-84.82v.24l9.19,18.1h75.62c12.78,0,23.13-12.36,23.13-27.32s-10.35-27.32-23.13-27.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,45.86v36.42c0,14.96,10.46,27.32,23.24,27.32H98.83l9.22-18.16v-.18H23.24c-4.3,0-7.71-4.03-7.71-8.98v-9.11H108.05v-18.21H15.53v-9.11c0-4.94,3.41-9.11,7.71-9.11H108.05V18.54H23.24C10.46,18.54,0,30.77,0,45.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "635.97 93.59 555.38 93.59 540.21 109.41 620.75 109.41 635.97 93.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M636.28,177.63h-.07c-.52-6.7-2.37-13.26-5.42-19.26-3.05-6-7.27-11.35-12.41-15.74-5.14-4.39-11.1-7.7-17.52-9.8-6.43-2.1-13.21-2.9-19.94-2.38-6.73,.51-13.32,2.36-19.35,5.39-6.03,3.04-11.4,7.24-15.81,12.35-4.41,5.11-7.74,11.04-9.85,17.44-.56,1.73-1.06,3.5-1.43,5.28v-.07c-1.41-3.31-3.42-6.3-5.96-8.85-2.53-2.52-8.49-6.16-11.82-7.54l11.76-12.38,18.1-19.03h-19.27l-27.76,28.82-9.76,10.13c-1.67,1.66-3.07,3.53-4.25,5.53-.82-2.87-1.85-5.67-3.17-8.36-.07-.14-.14-.27-.2-.41-.06-.13-.13-.27-.2-.41-.14-.28-.28-.56-.45-.84-.49-.91-1.01-1.82-1.55-2.71-2.25-3.68-4.98-7.02-8.08-10l30.76-33.98,.7-.76,.61-.66,14.48-15.8h-104.66l.15,15.94h69.74l-19.47,21.41-.43,.55-15.79,17.42,1.5,.61h0c3.5,1.41,9.73,5.82,9.73,5.82,3.4,2.9,6.19,6.44,8.21,10.44,1.43,2.8,2.46,5.77,3.07,8.82,.08,.39,.15,.8,.21,1.19l.02,.16c.14,.91,.26,1.82,.33,2.73,.28,3.59,0,7.19-.84,10.69-.21,.82-.42,1.63-.68,2.45l-.05,.12v.09c-.63,1.8-1.36,3.55-2.25,5.23-.77,1.49-1.69,2.94-2.67,4.32-2.67,3.67-6.05,6.77-9.92,9.13s-8.19,3.94-12.67,4.65c-4.48,.7-9.08,.54-13.49-.54-4.41-1.05-8.58-2.96-12.27-5.63-2.32-1.68-4.43-3.64-6.24-5.81-1.67-1.98-3.1-4.15-4.27-6.47-2.06-4.04-3.28-8.43-3.64-12.93-.07-1.03-.12-2.05-.09-3.08,0-.63,.02-1.26,.07-1.89,.12-1.92,.42-3.83,.87-5.72h0c.21-.82,.42-1.63,.68-2.45l.07-.21c.14-.47,.31-.93,.49-1.38,1.41-3.78,3.5-7.26,6.12-10.34,2.96-3.43,6.57-6.26,10.62-8.31,3.16-1.6,6.53-2.68,10.01-3.25l14.41-15.94c-5.53-.97-11.19-1.02-16.75-.14-6.61,1.05-12.95,3.36-18.65,6.84-5.7,3.48-10.65,8.05-14.59,13.42-3.31,4.55-5.84,9.59-7.48,14.94-.31,1-.59,2.01-.82,3.01l-.05,.2c-.15,.63-.29,1.24-.4,1.88-.89,4.48-1.15,9.06-.8,13.63,.52,6.63,2.35,13.12,5.37,19.05,3.03,5.93,7.2,11.23,12.27,15.55,5.09,4.34,10.98,7.63,17.33,9.69,6.36,2.08,13.06,2.87,19.73,2.36,5.7-.44,11.26-1.82,16.49-4.09,2.13-.93,4.22-2.01,6.22-3.22,5.21-3.17,9.8-7.26,13.56-12.05,3.61-4.62,6.43-9.85,8.26-15.43,.1-.34,.2-.68,.29-1.02,.09-.34,.19-.68,.29-1.02,1.17,2.01,2.6,3.88,4.25,5.53,2.53,2.52,5.56,4.53,8.89,5.91,3.33,1.38,6.9,2.08,10.48,2.08s7.15-.7,10.48-2.08c3.33-1.38,6.33-3.38,8.89-5.91,2.51-2.5,4.5-5.46,5.89-8.73,.91,4.48,2.44,8.82,4.53,12.91,3.05,6,7.27,11.35,12.41,15.73,5.14,4.39,11.1,7.7,17.52,9.81,6.43,2.1,13.21,2.89,19.94,2.38,6.73-.51,13.32-2.36,19.35-5.39,6.03-3.03,11.4-7.24,15.81-12.35,4.41-5.11,7.74-11.04,9.85-17.44,2.11-6.4,2.91-13.14,2.39-19.84Zm-127.11,16.79c-7.13,0-12.9-5.74-12.9-12.84s5.77-12.84,12.9-12.84,12.9,5.74,12.9,12.84-5.77,12.84-12.9,12.84Zm108.95-2.03c-1.43,4.34-3.71,8.36-6.68,11.84-2.98,3.48-6.64,6.33-10.74,8.38-4.1,2.08-8.56,3.31-13.14,3.67-4.57,.35-9.17-.21-13.56-1.61-4.36-1.42-8.4-3.69-11.89-6.65-3.5-2.96-6.36-6.61-8.42-10.67-2.09-4.08-3.33-8.52-3.68-13.07-.35-4.55,.21-9.13,1.62-13.49,1.43-4.34,3.71-8.36,6.69-11.84s6.64-6.33,10.74-8.38c4.1-2.08,8.56-3.31,13.14-3.67,4.57-.35,9.17,.21,13.56,1.61,4.36,1.42,8.4,3.69,11.89,6.65s6.36,6.61,8.42,10.67c2.09,4.08,3.33,8.52,3.68,13.07,.35,4.55-.19,9.15-1.62,13.49Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEasy360RedAndBlue);
export default __webpack_public_path__ + "static/media/logo-easy360-red-and-blue.a5939939663533e43445e0eb91259e91.svg";
export { ForwardRef as ReactComponent };